import React from 'react';
import AboutImage from '../../../assets/aa.jpeg';
import './about.css';

const About = () => {
  return (
    <section id="about" className="dummy-about-section" data-aos="fade-in">
      <div className="container about__container">
        <div className="about__left">
          <div className="about__portrait">
            <img src={AboutImage} alt="About Us" />
          </div>
        </div>
        <div className="about__right">
          <h2 className="about-title">About Us</h2>
          <div className="about-content-text">
            <p>
              SkillBridge is the dedicated training and internship certificate program division of Int-Elligence Tech Solutions Plc, established to prepare students, early-career professionals, and career switchers for meaningful roles within the UK technology sector. Our focus is simple: to ensure that learning translates directly into employability. We are built around industry expectations, not academic assumptions.
            </p>
            <p>
              We do not believe in theory-heavy learning that leaves candidates underprepared for real responsibilities. Instead, we design programs around the work employers actually hire for — practical tools, relevant workflows, and project environments that reflect modern technology roles. Our approach prioritises applied experience, structured mentorship, and measurable capability development.
            </p>
            <p>
              Through industry-aligned training, internship-backed certificate pathways, and real-world client-inspired projects, SkillBridge equips participants with more than knowledge. We provide 1:1 mentorship from UK industry professionals, flexible delivery models, and career-focused guidance that supports both confidence and competence. Every element of our programs is designed to support long-term professional growth.
            </p>
            <p>
              Our mission is to bridge the gap between academic learning and the expectations of UK employers. We aim to empower individuals with practical skills, industry awareness, and globally recognised credentials that strengthen their professional credibility. At SkillBridge, we are committed to developing capable, work-ready professionals prepared to contribute from day one.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;